export default function ContextDmLauncherPage() {
  const examples = [
    {
      label: 'Message user 245 from test group',
      href: '/messages?partnerUserId=245&originGroupId=group_test_dates_001',
    },
    {
      label: 'Message user 245 from test activity',
      href: '/messages?partnerUserId=245&originActivityId=activity_test_movie_001',
    },
  ];

  return (
    <div>
      <div className="page-header">
        <div>
          <div className="page-title">Context DM launcher</div>
          <div className="page-subtitle">Temporary test entry points for group/activity-origin direct messages.</div>
        </div>
      </div>

      <div className="card">
        <div className="section">
          <div className="section-title">Examples</div>
          <div className="chip-row" style={{ marginBottom: "0.75rem" }}>
            <a className="btn-outline" href="/groups">Discover groups</a>
            <a className="btn-outline" href="/group-invites/accept">Accept invite</a>
          </div>
          <div className="chip-row">
            {examples.map((x) => (
              <a key={x.href} className="btn-outline" href={x.href}>
                {x.label}
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
